import './TestConsolePane.scss';

import { ILogsError } from '../../types/logsTypes';
import { NetworkInfo } from '../NetworkInfo/NetworkInfo';
interface Props {
  id: string;
  request: string;
  response: string;
  error: ILogsError;
}

const TestConsolePane = (props: Props) => {
  const { request, response, error } = props;

  const parsedRequest = JSON.parse(request || '{}');
  const parsedResponse = JSON.parse(response || '{}');

  return (
    <NetworkInfo
      general={{
        method: parsedRequest.method,
        url: parsedRequest.url,
        statusCode: parsedResponse.status_code,
        responseTimeMs: parsedResponse.response_time_ms,
        spaceBetween: true,
      }}
      request={{
        headers: parsedRequest.headers,
        json: parsedRequest?.data,
      }}
      response={{
        headers: parsedResponse.headers,
        json: parsedResponse?.data,
      }}
      ids={{
        tId: parsedRequest?.headers?.['transaction-id'] ?? '',
        cId: parsedRequest?.headers?.['correlation-id'] ?? '',
      }}
      error={error}
    />
  );
};

export default TestConsolePane;
